// extracted by mini-css-extract-plugin
export default {"thumb":"CustomMarkerSliderThumb__thumb--3geD6","withAnimation":"CustomMarkerSliderThumb__withAnimation--1f4iP","thumbPointer":"CustomMarkerSliderThumb__thumbPointer--3rr8-"};